import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { changeProject, getProject } from '../../../redux/projects/projectsActions';
import { resetEditProjectPage } from '../../../redux/projects/projectsReducer';
import NameSection from '../name/NameSection';
import ShareSection from '../share/ShareSection';
import AccessUsersSection from '../access-users/AccessUsersSection';

import scss from './EditActiv8.module.scss';

function EditActiv8() {
  const { id } = useParams();
  const dispatch = useDispatch();

  const handleSaveNameSection = async ({ id, editProject, values }) => {
    const { projectName } = values;

    await dispatch(
      changeProject({
        id,
        projectType: editProject.projectType,
        values: { projectName },
      }),
    );
  };

  useEffect(() => {
    dispatch(getProject({ id }));

    return () => {
      dispatch(resetEditProjectPage());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={scss.pageWrapper}>
      <NameSection onSubmit={handleSaveNameSection} />
      <ShareSection />
      <AccessUsersSection />
    </div>
  );
}

export default EditActiv8;
